import { CustomerSelection } from "../../CheckoutCustomer/CustomerSelection";
import { useCheckoutCustomer } from "../../CheckoutCustomer/useCheckoutCustomer";
import primaryComponents from "../../../../primaryComponents";
import { useDispatch, useSelector } from "react-redux";
import { useGetCustomerStoreWallets } from "../../../../../hooks/api/queries";
import secondaryComponents from "../../..";
import { pathConstants } from "../../../../../routes/pathContants";
import { Link, useParams } from "react-router-dom";
import { formatCurrency } from "../../../../../helpers";
import { setApiErrorMessage } from "../../../../../store/modules/apiErrorHandler";
import { useCreateStoreWalletSession } from "../../../../../hooks/api/mutations/useInventory";
import { useEffect, useState } from "react";
import StoreWalletOtpWidget from "./StoreWalletOtpWidget";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import externalStyles from "../../Loyalty/styles.module.scss";

export const WalletDetailsForm = ({
  amount = 0,
  is_split = false,
  setStoreWallet = () => {},
  closeModal = () => {},
}) => {
  const dispatch = useDispatch();
  const { store_id } = useParams();
  const [sessionId, setSessionId] = useState(null);
  const { customerInfo, setCustomerInfo } = useCheckoutCustomer();
  const { store_wallet } = useSelector((state) => state?.checkoutReducer);
  const { data, isLoading: isLoadingStoreWallets } = useGetCustomerStoreWallets(
    { customer_id: customerInfo?.customer_id },
  );
  const storeWallets = data?.data;

  const { mutate, isLoading } = useCreateStoreWalletSession();
  const handleCreateStoreWalletSession = () => {
    if (store_wallet && store_wallet?.session_id) return closeModal();

    mutate(
      {
        is_split,
        store_id,
        wallet_id: store_wallet?.wallet_id,
        amount: amount,
      },
      {
        onSuccess: (res) => {
          if (res?.data?.data?.otp_required)
            return setSessionId(res?.data?.data?.session_id);

          setStoreWallet({
            ...store_wallet,
            session_id: res?.data?.data?.session_id,
          });
          closeModal();
        },
      },
    );
  };

  const setWalletDetails = (wallet) => {
    setStoreWallet({
      balance: wallet?.balance,
      currency_code: wallet?.currency_code,
      is_subwallet: wallet?.is_subwallet,
      tag: wallet?.tag,
      wallet_id: wallet?.id,
    });
  };

  useEffect(() => {
    if (
      storeWallets?.length === 1 &&
      store_wallet?.wallet_id !== storeWallets?.[0]?.id
    )
      return setWalletDetails(storeWallets?.[0]);

    if (store_wallet?.wallet_id === storeWallets?.[0]?.id) return;

    setWalletDetails(null);
  }, [storeWallets]);

  return (
    <>
      <div className="p-2">
        <h4 className="text-center mb-3">Add Wallet Details</h4>

        <CustomerSelection
          customerInfo={customerInfo}
          setCustomerInfo={(data) => {
            setCustomerInfo(data);
          }}
          showAddCustomer={false}
        />

        {customerInfo ? (
          <secondaryComponents.LoaderHelper
            isLoading={isLoadingStoreWallets}
            classNames={"mt-3"}
          >
            <div
              className={`${globalStyles.cardWithBackground} mt-3`}
              style={{ background: "rgba(243, 243, 243, 1)" }}
            >
              <h6 className="mb-0">Store Wallet Details</h6>
              <div
                className={`${globalStyles.cardWithBorder} white w-100`}
                style={{ borderRadius: 0 }}
              >
                {storeWallets?.length > 1 ? (
                  <primaryComponents.SelectField
                    idKey={"id"}
                    nameKey={"name"}
                    value={store_wallet?.tag || "Select wallet"}
                    options={storeWallets
                      ?.filter((data) => data?.tag)
                      ?.map((data) => ({
                        id: data?.id,
                        name: (
                          <div
                            className="d-flex align-items-center justify-content-between"
                            style={{ gap: "30px" }}
                          >
                            <div>{data?.tag}</div>
                            <div
                              className={`${data?.is_subwallet ? "gray--squared" : "gray--primary"}`}
                            >
                              {data?.is_subwallet
                                ? "Sub-wallet"
                                : "Primary Wallet"}
                            </div>
                          </div>
                        ),
                      }))}
                    onChange={(value) => {
                      const wallet = storeWallets?.find(
                        (wallet) => wallet?.id === value,
                      );
                      setWalletDetails(wallet);
                    }}
                    isSearchable={false}
                    floatError={false}
                  />
                ) : null}

                {store_wallet?.wallet_id ? (
                  <div className={"text-center"}>
                    <p
                      className={`${externalStyles.availableBalance} small-text-size`}
                    >
                      Available Balance
                    </p>
                    <h5 className="text-center mb-0">
                      {formatCurrency({
                        value: store_wallet?.balance,
                        currencyCode: store_wallet?.parent_store?.currency_code,
                      })}
                    </h5>

                    <p className="small-text-size mt-3">
                      Manage wallets in{" "}
                      <Link
                        className="small-text-size purple--text"
                        style={{ textDecoration: "underline" }}
                        to={pathConstants.INVENTORY_STORE_WALLET_LIST}
                        target="_blank"
                      >
                        Store Wallet
                      </Link>
                    </p>
                  </div>
                ) : null}

                {storeWallets?.length === 0 ? (
                  <div className="text-center">
                    <p className="dark--text mb-0">
                      The selected customer does not have a wallet{" "}
                    </p>
                    <Link
                      className="purple--text small-text-size"
                      style={{ textDecoration: "underline" }}
                      to={pathConstants.INVENTORY_STORE_WALLET_LIST}
                      target="_blank"
                    >
                      Create Wallet
                    </Link>
                  </div>
                ) : null}
              </div>
            </div>
          </secondaryComponents.LoaderHelper>
        ) : null}

        <primaryComponents.Button
          classNames={"mt-4 ml-auto btn btn--primary cover"}
          isDisabled={isLoading}
          isLoading={isLoading}
          loadingText={"Verifying..."}
          onClick={() => {
            if (!store_wallet)
              return dispatch(
                setApiErrorMessage({
                  message:
                    "Please ensure a customer wallet as been selected before proceeding with store wallet payment",
                }),
              );

            handleCreateStoreWalletSession();
          }}
        >
          Apply
        </primaryComponents.Button>
      </div>

      <secondaryComponents.Modal
        isActive={sessionId !== null}
        width={500}
        closeModal={() => setSessionId(null)}
      >
        <StoreWalletOtpWidget
          sessionId={sessionId}
          callBackFunc={(otp_code) => {
            setStoreWallet({
              ...store_wallet,
              otp_code: otp_code,
              session_id: sessionId,
            });
            setSessionId(null);
            closeModal();
          }}
        />
      </secondaryComponents.Modal>
    </>
  );
};
